import * as actionsActions from "../actions/actions";
import {connect} from "redux-vue";
import ModalTemplate from "./ModalTemplate";

const ActionMessageModal = {
  props: ['app', 'action', 'fetchActions'],
  methods: {
    handleOk() {
      this.fetchActions();
    }
  },
  render(h) {
    const messageHTML = this.action.errorMessageHTML || this.action.successMessageHTML;
    if (messageHTML && !this.app.completed) {
      return (
        <ModalTemplate>
          <div class="overflow-y-auto pt-12 lg:pt-24" style="max-height: 35rem;">
            <div class="w-10/12 mx-auto text-base lg:text-xl">
              <div domPropsInnerHTML={messageHTML} />
              <div class="sticky bottom-0 pb-6 lg:pb-12" style="background: rgba(255,255,255,0.90);">
                <button type="button" onClick={this.handleOk}
                        class="mt-6 rounded-full bg-brand-green-400 p-10 py-1 text-white uppercase text-sm font-bold focus:outline-none">
                  Ok
                </button>
              </div>
            </div>
          </div>
        </ModalTemplate>
      );
    }
    return null;
  }
};

function mapStateToProps(state) {
  return {
    app: state.simulation.app,
    action: state.simulation.action,
  };
}

function mapActionToProps(dispatch) {
  return {
    fetchActions: () => dispatch(actionsActions.fetchActions()),
  };
}

export default connect(mapStateToProps, mapActionToProps)(ActionMessageModal);

